import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 20px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    background: ${colors.white};

    & > h2 {
        color: ${colors.brandPrimary};
        min-width: 300px;
    }
`;
